import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle } from 'lucide-react';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errorMsg, setErrorMsg] = useState('');
  const { isAuthenticated, refresh } = useAuth();

  useEffect(() => {
    if (!token || !token.trim()) {
      setStatus('error');
      setErrorMsg('Kein gültiger Verifizierungslink.');
      return;
    }
    authAPI.verifyEmail({ token: token.trim() })
      .then(() => {
        setStatus('success');
        refresh();
      })
      .catch((err) => {
        setStatus('error');
        setErrorMsg(err?.response?.data?.detail || 'Verifizierung fehlgeschlagen.');
      });
  }, [token, refresh]);

  return (
    <div className="min-h-screen bg-[#F5F5F7] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-sm text-center">
        {status === 'loading' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-2 border-[#0071E3] border-t-transparent mx-auto mb-6" />
            <p className="text-[#86868B]">E-Mail wird verifiziert...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-[#34C759] mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-[#1D1D1F] mb-2">E-Mail bestätigt</h1>
            <p className="text-[#86868B] mb-6">Deine E-Mail-Adresse wurde erfolgreich bestätigt.</p>
            <Link to={isAuthenticated ? '/dashboard' : '/login'}>
              <Button className="btn-primary">
                {isAuthenticated ? 'Zum Dashboard' : 'Zur Anmeldung'}
              </Button>
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-[#1D1D1F] mb-2">Verifizierung fehlgeschlagen</h1>
            <p className="text-[#86868B] mb-6">{errorMsg}</p>
            <Link to="/">
              <Button variant="outline" className="btn-secondary">Zur Startseite</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
